import { FC } from "react"

export interface IHowMuchTable {
  blok: {
    items: { distance: string; cost: string }[]
    title: string
    subtitle?: string
  }
}

const HowMuchTable: FC<IHowMuchTable> = ({ blok }) => (
  <div className="mx-auto my-8 px-4 pt-6 md:max-w-3xl md:px-6">
    {blok.title && (
      <h2
        className="font-merriweather mb-6 text-left text-3xl leading-[48px] lg:text-[40px] lg:leading-[72px] lg:text-center"
        dangerouslySetInnerHTML={{ __html: blok.title }}
      />
    )}
    {blok.subtitle && (
      <p
        className="mb-5 -mt-2 text-left md:mt-0 md:mb-8 pb-2 text-lg leading-[40px] md:text-2xl md:leading-[36px] font-inter lg:text-center"
        dangerouslySetInnerHTML={{ __html: blok.subtitle }}
      />
    )}
    <div className="mx-auto max-w-[460px] rounded-[28px] border border-gray-200/50 bg-white px-8 py-5 md:max-w-[520px] md:px-10 md:py-6">
      <table className="mt-0 w-full border-separate border-spacing-y-5 text-left md:mt-0 md:border-spacing-y-6">
        <thead>
          <tr>
            <th className="whitespace-nowrap pr-4 align-bottom text-[13px] font-semibold uppercase tracking-[0.14em] text-gray4 md:text-[14px]">
              Distance (miles)
            </th>
            <th className="whitespace-nowrap align-bottom text-right text-[13px] font-semibold uppercase tracking-[0.14em] text-gray4 md:text-[14px]">
              Cost (incl. fee)
            </th>
          </tr>
        </thead>
        <tbody>
          {blok.items?.map((row, idx) => (
            <tr key={idx}>
              <td className="pr-4 text-[20px] font-semibold text-secondary-900 md:text-[21px]">
                {row.distance}
              </td>
              <td className="text-right text-[20px] font-bold text-blue7 md:text-[21px]">
                {row.cost}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default HowMuchTable
